"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PAYMENT_TYPE = {
    WEBPAY: 'webpay',
    APEXX: 'apexx',
    VISANET: 'visanet',
    '2C2P': '2C2P',
    EWAY: 'eway',
    MERCADOPAGO: 'mercadopago',
    STRIPE: 'stripe',
};
exports.default = PAYMENT_TYPE;
